import React, { useRef, useState } from 'react';
import { NavigationStepperItemType } from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import LaboratoryRequestCreateModal from '../../../Laboratory/Components/LaboratoryRequestCreate/LaboratoryRequestCreateModal';
import IssuedLaboratoryRequestsList, {
	IssuedLaboratoryRequestsListHandle,
} from '../../../Laboratory/Components/IssuedLaboratoryRequestsList/IssuedLaboratoryRequestsList';
import LaboratoryResultsListWrapper from '../../../Laboratory/Components/LaboratoryResultsList/LaboratoryResultsListWrapper';
import LaboratoryRequestTemplateWrapper from '../../../Laboratory/Components/LaboratoryRequestTemplate/LaboratoryRequestTemplateWrapper/LaboratoryRequestTemplateWrapper';

interface Props {
	patientId: string;
	workplaceId: string;
}

const PatientTreatmentLaboratories: React.FC<Props> = ({
	patientId,
	workplaceId,
}) => {
	const issuedRequestsListRef =
		useRef<IssuedLaboratoryRequestsListHandle>(null);
	const [isCreateLaboratoryRequestOpen, setIsCreateLaboratoryRequestOpen] =
		useState(false);

	const handleOnCreateRequest = async () => {
		setIsCreateLaboratoryRequestOpen(false);
		issuedRequestsListRef.current?.refresh();
	};

	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.medicalRequestForms.createARequisition',
			key: 'newLaboratoryRequest',
			onClick: () => setIsCreateLaboratoryRequestOpen(true),
		},
		{
			name: 'component.patientTreatmentLaboratories.issuedLaboratoryRequests',
			key: 'issuedLaboratoryRequests',
			component: () => (
				<IssuedLaboratoryRequestsList
					workplaceId={workplaceId}
					patientId={patientId}
					ref={issuedRequestsListRef}
				/>
			),
		},
		{
			name: 'component.patientTreatmentLaboratories.laboratoryResults',
			key: 'laboratoryResults',
			component: () => <LaboratoryResultsListWrapper patientId={patientId} />,
		},
		{
			name: 'component.patientTreatmentLaboratories.laboratoryRequestsTemplates',
			key: 'laboratoryRequestsTemplates',
			component: () => (
				<LaboratoryRequestTemplateWrapper workplaceId={workplaceId} />
			),
		},
	];

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='issuedLaboratoryRequests'
				canSkip
				showStepNumbers={false}
			/>
			<LaboratoryRequestCreateModal
				isOpen={isCreateLaboratoryRequestOpen}
				onClose={() => setIsCreateLaboratoryRequestOpen(false)}
				onRequestCreate={handleOnCreateRequest}
				patientId={patientId}
				workplaceId={workplaceId}
			/>
		</>
	);
};

export default PatientTreatmentLaboratories;
